import { PublicProfileState } from '../types'

export const initialState: PublicProfileState = {
  profile: null,
  notification: null,
  publicStyleboards: undefined,
  isPublicProfilePageLoading: true,
  isPublicProfilePageLoaded: false,
  isPublicProfilePageLoadingFailed: false,
  isPublicProfilePageNoContent: false,
}
